export const TRANSFER_INVOICE_REPORT_LOADINGS = {
  GET_REPORT: "loadingTransferInvoiceReport"
};

export const reportTransferInvoiceTypes = {
  SET_TRANSFER_INVOICE_REPORT_FILTERS: "TRANSFER_INVOICE_REPORT/SET_FILTERS",
  RESTORE_INITIAL: "TRANSFER_INVOICE_REPORT/RESTORE_INITIAL",
};
